<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("checklist", 1) }} {{ $tc("category", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Checklist Categories' }"
        >{{ $tc("category", 2) }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row" style="height:70px">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="category_name"
                name="category_name"
                v-validate="'required'"
                v-model="category_name"
                placeholder="."
                v-b-tooltip.hover
                :title="$t('checklist_category_name')"
              />
              <label>Category Name</label>
            </div>
            <!--Tooltip :title="$t('checklist_category_name')" /--->
          </div>
          <p class="error_message">
            <span v-if="errors.has('category_name')">{{
              errors.first("category_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <textarea
                id="category_description"
                name="category_description"
                v-validate="'required'"
                v-model="category_description"
                placeholder="Description"
                v-b-tooltip.hover
                :title="$t('checklist_category_description')"
              />
              <!-- <label>Description</label> -->
            </div>
            <!--Tooltip :title="$t('checklist_category_description')" /-->
          </div>
          <div class="ml-3">
            <p class="error_message">
              <span v-if="errors.has('category_description')">{{
                errors.first("category_description")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("active") }}</label>

            <b-form-checkbox
              type="checkbox"
              class="j-checkbox mb-0"
              v-model="category_is_active"
            />
          </div>
        </div>
      </div>
      <div class="col-12 text-center">
        <button @click.prevent.stop="editCategory()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistService from "@/services/ChecklistService";

export default {
  data() {
    return {
      category_name: "",
      category_description: "",
      category_is_active: true
    };
  },
  mounted() {
    this.getCategoryData();
  },
  methods: {
    getCategoryData() {
      const { cc_id } = this.$route.params;
      ChecklistService.GetCategory({ cc_id: cc_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              (this.category_name = data.Records[0].cc_name),
                (this.category_description = data.Records[0].cc_description),
                (this.category_is_active = data.Records[0].cc_is_active = "Y"
                  ? true
                  : false);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    editCategory() {
      const { cc_id } = this.$route.params;

      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            category_name: this.category_name,
            description: this.category_description,
            category_is_active: this.category_is_active,
            cc_id: cc_id
          };
          ChecklistService.EditCategory(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/checklist-categories"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CheckListCategoriesComponents/editChecklistCategory.vue